import createSvgIcon from 'shared/utils/createSvgIcon';

export default createSvgIcon(
  <g xmlns="http://www.w3.org/2000/svg" transform="translate(1.742 431.494)">
    <path
      d="M7.2-413.617a8.948,8.948,0,0,1-8.939-8.938A8.948,8.948,0,0,1,7.2-431.494a8.97,8.97,0,0,1,7.218,3.679,1.193,1.193,0,0,1-.261,1.667,1.194,1.194,0,0,1-1.667-.261,6.576,6.576,0,0,0-5.29-2.7,6.56,6.56,0,0,0-6.553,6.553A6.56,6.56,0,0,0,7.2-416a6.575,6.575,0,0,0,5.29-2.7,1.193,1.193,0,0,1,1.667-.26,1.193,1.193,0,0,1,.261,1.667A8.97,8.97,0,0,1,7.2-413.617Z"
      transform="translate(0)"
    />
    <g transform="translate(8.745 -426.593)">
      <rect
        width="9.108"
        height="3.812"
        rx="1.836"
        transform="translate(0 2.131)"
      />
      <path
        d="M42.112-417.184l-3.972,3.972a.221.221,0,0,1-.377-.157V-421a.221.221,0,0,1,.377-.156Z"
        transform="translate(-29.401 421.222)"
      />
    </g>
  </g>,
  '0 0 23.198 17.877'
);
